import React from 'react';
import { useEffect, useState } from 'react';
import { ContentfulStandardTerm } from '../../../interfaces';
import { Translate } from '../../layout';
import { RichTextRenderer } from '../shared/rich-text-renderer';

import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { withContentfulLivePreviewSys } from '../../../utils/with-contentful-live-preview-sys';

import './standard-term.scss';


const StandardTerm = (props: ContentfulStandardTerm) => {
  const liveData = useContentfulLiveUpdates(withContentfulLivePreviewSys(props));
  const {
    contentful_id,
    icon,
    title, 
    description,
    showLearnMore,
    learnMoreLink,
    optionalButtonLabel,
    optionalButtonLink,
  } = liveData;
  
  const inspector = useContentfulInspectorMode(
    contentful_id ? { entryId: contentful_id } : undefined
  );

  const iconInspector = inspector({ fieldId: 'icon' });
  const titleInspector = inspector({ fieldId: 'text', entryId: title?.contentful_id });
  const descriptionInspector =  inspector({ fieldId: 'text', entryId: description?.contentful_id });
  const learnMoreInspector = inspector({ fieldId: 'learnMoreLink' });
  const optionalButtonLabelInspector = inspector({ fieldId: 'optionalButtonLabel' });
  const optionalButtonLinkInspector = inspector({ fieldId: 'optionalButtonLink' });

  const pageTitle = title?.text || '';
  const pageDescription = description?.text?.raw ?? description?.text?.json;
  
  return (
    <div className={`standard-term-card standard-term-${title}`}>
      {icon?.file?.url && (
        <div className="standard-term-card__image" {...iconInspector}>
          <img
            className="image"
            src={icon.file.url}
            alt={title?.text || "icon"}
          />
        </div>
      )}

      {pageTitle &&
        <h2 className='standard-term-card__title' {...titleInspector}>{pageTitle}</h2>
      }

      {pageDescription && (
        <div className="standard-term-card__description" {...descriptionInspector} >
        <RichTextRenderer raw={pageDescription} />
        </div>
      )}

      <div className="standard-term-card__content">
        {showLearnMore && learnMoreLink && (
          <a href={learnMoreLink} target="_blank" rel="noreferrer" className="information-button" {...learnMoreInspector}>
            <Translate id="component.standard-term" />
          </a>
        )}
        {optionalButtonLabel && optionalButtonLink && (
          <a href={optionalButtonLink} target="_blank" rel="noreferrer" className="information-button" {...optionalButtonLabelInspector} {...optionalButtonLinkInspector}>
            {optionalButtonLabel}
          </a>
        )}
      </div>
    </div>
  );
};

export default StandardTerm;